         
export const showSnackbar = (message, duration = 3000) => {
    //ToDo: Move it in a common place or replace it by snackbar modules 
    let toaster = document.getElementById('snackbar');
    toaster.innerHTML = message;
    toaster.className = "show";
    setTimeout(function(){ toaster.className = toaster.className.replace("show", ""); }, duration);
}   
